import type { SVGProps } from 'react';

const SvgClass19 = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_1208_38575)'>
      <path
        d='M12 24C18.6274 24 24 18.6278 24 12.0003C24 5.37279 18.6274 0 12 0C5.37257 0 0 5.37279 0 12.0003C0 18.6278 5.37257 24 12 24Z'
        fill='#FF4040'
      />
      <path
        d='M6.22318 7C5.54867 7 5 7.46628 5 8.03948C5 8.61292 5.54867 9.07919 6.22318 9.07919C6.5448 9.07919 6.55033 9.14216 6.55337 9.17109V15.9605C6.55337 16.5337 7.10204 17 7.77654 17C8.45133 17 9 16.5337 9 15.9605V9.1711C9 8.29825 8.26051 7 6.22318 7Z'
        fill='white'
      />
      <path
        d='M15.0001 7.00001C12.7943 7.00001 11 8.65075 11 10.6799C11 12.4682 12.3942 13.961 14.235 14.2905L13.3798 15.3349C13.1982 15.5568 13.1213 15.8303 13.1634 16.1055C13.2056 16.3805 13.3614 16.624 13.6026 16.791C13.8 16.9278 14.0348 17 14.2818 17C14.6405 17 14.9697 16.8493 15.1853 16.5863L18.1557 12.9586C18.1918 12.9145 18.2206 12.867 18.2483 12.8192C18.7194 12.2155 19 11.478 19 10.6799C19 8.65074 17.2057 7.00001 15.0001 7.00001ZM15.0001 12.2806C14.0406 12.2806 13.26 11.5624 13.26 10.6799C13.26 9.7974 14.0406 9.0792 15.0001 9.0792C15.9593 9.0792 16.74 9.79739 16.74 10.6799C16.74 11.5624 15.9593 12.2806 15.0001 12.2806Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_1208_38575'>
        <rect width={24} height={24} rx={12} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClass19;
